import { itIT } from "@mui/x-date-pickers/locales";

/**
 * calendarLocalization returns the configuration object used to localize calendar
 * UI components such as placeholders, hints, etc.
 *
 * @param locale the locale for which calendar localization configuration is requested
 * @returns      the calendar localization object or undefined if locale is not supported
 */
export const calendarLocalization = (locale: string): any => {
	switch (locale) {
		case "it":
			return itIT.components.MuiLocalizationProvider.defaultProps.localeText;
		default:
			// Defaults to "en".
			return undefined;
	}
};
